import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faAlignJustify } from '@fortawesome/free-solid-svg-icons/faAlignJustify';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';

library.add([
	faSpinner,
	faShoppingCart,
	faStar,
	faAlignJustify,
	faTimes,
	faMapMarkerAlt,
	faSync,
]);
